/**
 * RequireAuth — wraps routes that need a verified session.
 * Redirects to /login if no session is present.
 * Shows nothing while session is loading (avoids flash of protected content).
 */

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Minimal loading state — just blank until session resolves.
    // Keeps the UX snappy; auth check is fast (local storage read).
    return null;
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
